import React from "react";

const COLORS = {
  blue: "bg-blue-100 text-blue-700",
  amber: "bg-amber-100 text-amber-700",
  emerald: "bg-emerald-100 text-emerald-700",
  rose: "bg-rose-100 text-rose-700",
};

export default function StatCard({ Icon, label, value, color }) {
  return (
    <div className="bg-white border border-zinc-200 rounded-xl p-4">
      <div className={`w-10 h-10 rounded-xl ${COLORS[color]} flex items-center justify-center mb-2`}>
        <Icon className="w-5 h-5" strokeWidth={2.5} />
      </div>
      <p className="text-xs font-bold text-zinc-500 uppercase tracking-wide">{label}</p>
      <p className="text-2xl font-black text-zinc-900">{value}</p>
    </div>
  );
}
